import { Navigate } from 'react-router-dom';
import { useForBinding } from '../contexts/ForBindingContext';

interface OwnerOnlyGuardProps {
	children: React.ReactNode;
	fallback?: string;
}

export const OwnerOnlyGuard = ({ children, fallback = '/' }: OwnerOnlyGuardProps) => {
	const { isForBinding } = useForBinding();
	if (isForBinding) return <Navigate to={fallback} replace />;
	return <>{children}</>;
};
